import { render } from "./EdgeReportCard.vue?vue&type=template&id=13a247d7&scoped=true"
import script from "./EdgeReportCard.vue?vue&type=script&lang=js"
export * from "./EdgeReportCard.vue?vue&type=script&lang=js"

import "./EdgeReportCard.vue?vue&type=style&index=0&id=13a247d7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13a247d7"]])

export default __exports__